import {GritxSelect} from './GritxSelect';
export default GritxSelect;
